<template>
  <div class="ai-visibility-detail-filters">
    <ai-visibility-select
      v-if="hasFilter('range')"
      :value="filters.range"
      :options="rangeOptions"
      aria-label="Date range"
      @input="emitFilter('range', $event)"
    >
    </ai-visibility-select>

    <ai-visibility-select
      v-if="hasFilter('model')"
      :value="filters.model"
      :options="modelOptions"
      aria-label="AI model"
      @input="emitFilter('model', $event)"
    >
    </ai-visibility-select>
  </div>
</template>

<script>
import AiVisibilitySelect from '../ui/controls/AiVisibilitySelect.vue'

export default {
  name: 'DetailFilters',
  components: {
    AiVisibilitySelect,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    rangeOptions: {
      type: Array,
      required: true,
    },
    modelOptions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    hasFilter (key) {
      return Object.prototype.hasOwnProperty.call(this.filters, key)
    },
    emitFilter (key, value) {
      this.$emit('update-filter', { key, value })
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-detail-filters {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
}

@media (max-width: 860px) {
  .ai-visibility-detail-filters {
    justify-content: flex-start;
    width: 100%;
  }
}
</style>
